import i18n from '@ps/lang'
import _ from 'lodash'
import { VpCategories } from './categories'
import { VpBaseMethods } from './vp-base-methods'
import { VpMaskMethods, VpMaskAstAction } from './mask'
import { VpCarouselMethods, VpCarouselAstAction } from './carousel'

// 编辑器 ast action 配置，一般用在配置国际化配置与表单 UI
// 编辑器只允许配置与 UI 展示相关的内容。不可增加其他内容，如不可增加响应事件的参数，只可修改响应事件参数的 UI 相关配置
type EditorAstActionItem = {
  label: string
  category: string
  paramFormConfig: {
    [key: string]: any
  }
}

// 动画
export const VpTweenMethods = {
  vpPlayTweenByUuid: 'vpPlayTweenByUuid',
  vpStopTweenByUuid: 'vpStopTweenByUuid',
  vpPlayTweenByUuidGoOn: 'vpPlayTweenByUuidGoOn',
  vpResetTweenPropByUuid: 'vpResetTweenPropByUuid',
  vpPlayTween: 'vpPlayTween',
  vpPlayTweenGoOn: 'vpPlayTweenGoOn',
  vpStopTween: 'vpStopTween',
  vpResetTweenProp: 'vpResetTweenProp',
  vpPlayTweenChildrenAll: 'vpPlayTweenChildrenAll',
  vpStopTweenChildrenAll: 'vpStopTweenChildrenAll',
  vpPlayTweenChildrenAllGoOn: 'vpPlayTweenChildrenAllGoOn',
}
const VpTweenAstAction = {
  [VpTweenMethods.vpPlayTweenByUuid]: {
    label: '播放单个动画',
    category: VpCategories.animation.single,
    paramFormConfig: {
      vpTweenUuid: {
        title: '选择动画',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpTweenMethods.vpStopTweenByUuid]: {
    label: '暂停播放单个动画',
    category: VpCategories.animation.single,
    paramFormConfig: {
      vpTweenUuid: {
        title: '选择动画',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpTweenMethods.vpPlayTweenByUuidGoOn]: {
    label: '继续播放单个动画',
    category: VpCategories.animation.single,
    paramFormConfig: {
      vpTweenUuid: {
        title: '选择动画',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpTweenMethods.vpResetTweenPropByUuid]: {
    label: '返回单个动画初始状态',
    category: VpCategories.animation.single,
    paramFormConfig: {
      vpTweenUuid: {
        title: '选择动画',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpTweenMethods.vpPlayTween]: {
    label: '从头播放全部动画',
    category: VpCategories.animation.all,
  },
  [VpTweenMethods.vpPlayTweenGoOn]: {
    label: '继续播放全部动画',
    category: VpCategories.animation.all,
  },
  [VpTweenMethods.vpStopTween]: {
    label: '暂停播放全部动画',
    category: VpCategories.animation.all,
  },
  [VpTweenMethods.vpResetTweenProp]: {
    label: '返回全部动画初始状态',
    category: VpCategories.animation.all,
  },
  [VpTweenMethods.vpPlayTweenChildrenAll]: {
    label: '播放分组的全部动画',
    category: VpCategories.animation.all,
  },
  [VpTweenMethods.vpStopTweenChildrenAll]: {
    label: '暂停播放分组的全部动画',
    category: VpCategories.animation.all,
  },
  [VpTweenMethods.vpPlayTweenChildrenAllGoOn]: {
    label: '继续播放分组的全部动画',
    category: VpCategories.animation.all,
  },
}

// 序列帧
export const VpMovieClipMethods = {
  vpPlayMC: 'vpPlayMC',
  vpStopMC: 'vpStopMC',
}
const VpMovieClipAstAction = {
  [VpMovieClipMethods.vpPlayMC]: {
    label: '显示并播放序列帧',
    category: VpCategories.movieClip,
    paramFormConfig: {
      loop: {
        title: '无限循环',
        component: 'switch',
      },
      hideWhenFinished: {
        title: '播放完后是否隐藏',
        component: 'switch',
      },
      pingpong: {
        title: '来回播放',
        component: 'switch',
      },
      playTime: {
        title: '播放次数',
        component: 'input-number',
        field: {
          controlsPosition: 'right',
          min: 1,
        },
      },
    },
  },
  [VpMovieClipMethods.vpStopMC]: {
    label: '暂停序列帧',
    category: VpCategories.movieClip,
  },
}

// 龙骨
export const VpDragonBoneMethods = {
  vpPlaySKPlayer: 'vpPlaySKPlayer',
  vpStopSKPlayer: 'vpStopSKPlayer',
}
const VpDragonBoneAstAction = {
  [VpDragonBoneMethods.vpPlaySKPlayer]: {
    label: '播放龙骨',
    category: VpCategories.dragonBone,
    paramFormConfig: {
      animationName: {
        title: '动作名字',
        component: 'select',
        field: {
          options: [],
        },
      },
      loop: {
        title: '循环',
        component: 'switch',
      },
      speed: {
        title: '播放速度',
        component: 'input-number',
        field: {
          controlsPosition: 'right',
          min: 1,
        },
      },
    },
  },
  [VpDragonBoneMethods.vpStopSKPlayer]: {
    label: '暂停龙骨',
    category: VpCategories.dragonBone,
  },
}

// 粒子
export const VpParticleMethods = {
  vpPlayParticle: 'vpPlayParticle',
  vpStopParticle: 'vpStopParticle',
  vpClearParticle: 'vpClearParticle',
  vpParticleStartColor: 'vpParticleStartColor',
}
const VpParticleAstAction = {
  [VpParticleMethods.vpPlayParticle]: {
    label: '显示并播放粒子特效',
    category: VpCategories.particle,
  },
  [VpParticleMethods.vpStopParticle]: {
    label: '暂停播放粒子特效',
    category: VpCategories.particle,
  },
  [VpParticleMethods.vpClearParticle]: {
    label: '清除粒子特效',
    category: VpCategories.particle,
  },
  [VpParticleMethods.vpParticleStartColor]: {
    label: '粒子出生颜色',
    category: VpCategories.particle,
    paramFormConfig: {
      startColor: {
        title: '粒子出生颜色',
        component: 'color-picker',
      },
    },
  },
}

// 基础行为
export { VpBaseMethods }

const VpBasicAstAction = {
  [VpBaseMethods.vpSwitchScene]: {
    label: '跳转指定场景',
    category: VpCategories.basic.switchAndAction,
    paramFormConfig: {
      jumpSceneId: {
        title: '跳转的场景',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpBaseMethods.vpSwitchNextScene]: {
    label: '跳转到下一场景',
    category: VpCategories.basic.switchAndAction,
  },
  [VpBaseMethods.vpInstall]: {
    label: '跳转应用商店',
    category: VpCategories.basic.switchAndAction,
  },
  [VpBaseMethods.vpGameEnd]: {
    label: '上报试玩结束',
    category: VpCategories.basic.switchAndAction,
  },
  [VpBaseMethods.vpSendAction]: {
    label: '设置埋点',
    category: VpCategories.basic.switchAndAction,
    paramFormConfig: {
      action_id: {
        title: '设置埋点id',
        component: 'select',
        field: {},
      },
    },
  },
  [VpBaseMethods.vpPosition]: {
    label: '设置位置',
    category: VpCategories.basic.node,
    paramFormConfig: {
      position: {
        title: '位置',
        component: 'event-position',
      },
    },
  },
  [VpBaseMethods.vpScaleXY]: {
    label: '设置缩放',
    category: VpCategories.basic.node,
    paramFormConfig: {
      scale: {
        title: '缩放比例',
        component: 'event-scale',
      },
    },
  },

  [VpBaseMethods.vpRotate]: {
    label: '设置旋转',
    category: VpCategories.basic.node,
    paramFormConfig: {
      rotation: {
        title: '旋转角度',
        component: 'input',
        field: {
          type: 'number',
        },
      },
    },
  },
  [VpBaseMethods.vpWidth]: {
    label: '设置宽度',
    category: VpCategories.basic.node,
    paramFormConfig: {
      width: {
        title: '设置宽度',
        component: 'input',
        field: {
          type: 'number',
          step: 0.1,
        },
      },
    },
  },
  [VpBaseMethods.vpHeight]: {
    label: '设置高度',
    category: VpCategories.basic.node,
    paramFormConfig: {
      height: {
        title: '设置高度',
        component: 'input',
        field: {
          type: 'number',
          step: 0.1,
        },
      },
    },
  },
  [VpBaseMethods.vpShowHide]: {
    label: '显示/隐藏素材',
    category: VpCategories.basic.node,
    paramFormConfig: {
      isShow: {
        title: '显示/隐藏',
        component: 'select',
        field: {
          options: [
            {
              label: '显示',
              value: true,
            },
            {
              label: '隐藏',
              value: false,
            },
          ],
        },
      },
    },
  },
  [VpBaseMethods.vpAlpha]: {
    label: '设置透明度',
    category: VpCategories.basic.node,
    paramFormConfig: {
      alpha: {
        title: '设置透明度',
        // 透明度使用自定义插槽组件
        component: 'input-append',
        field: {
          type: 'number',
        },
      },
    },
  },
  [VpBaseMethods.vpColor]: {
    label: '设置颜色',
    category: VpCategories.basic.node,
    paramFormConfig: {
      color: {
        title: '设置颜色',
        component: 'color-picker',
      },
    },
  },
  [VpBaseMethods.vpWaitTime]: {
    label: '执行延迟',
    category: VpCategories.basic.timer,
    paramFormConfig: {
      ms: {
        title: '延迟时长',
        // 延迟时长使用自定义插槽组件
        component: 'input-append',
        field: {
          type: 'number',
        },
      },
      timerId: {
        title: '定时器名称',
        component: 'input',
        field: {
          type: 'text',
        },
      },
      lastTimerId: {
        title: '',
        component: 'input',
        visible: false,
      },
    },
  },
  [VpBaseMethods.vpClearTime]: {
    label: '取消执行延迟',
    category: VpCategories.basic.timer,
    paramFormConfig: {
      timerId: {
        title: '定时器ID',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpBaseMethods.enabledEvent]: {
    label: '禁用/启用事件',
    category: VpCategories.basic.event,
    paramFormConfig: {
      eventId: {
        title: '事件',
        component: 'select',
        field: {
          options: [],
        },
      },
      enabled: {
        title: '禁用/启用',
        component: 'switch',
      },
    },
  },
  [VpBaseMethods.enabledEventActive]: {
    label: '启用事件',
    category: VpCategories.basic.event,
    paramFormConfig: {
      eventId: {
        title: '事件',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpBaseMethods.enabledEventBan]: {
    label: '禁用事件',
    category: VpCategories.basic.event,
    paramFormConfig: {
      eventId: {
        title: '事件',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpBaseMethods.vpPlayBgm]: {
    label: '播放背景音乐',
    category: VpCategories.basic.bgm,
  },
  [VpBaseMethods.vpReplayBgm]: {
    label: '从头播放背景音乐',
    category: VpCategories.basic.bgm,
  },
  [VpBaseMethods.vpResumeBgm]: {
    label: '继续播放背景音乐',
    category: VpCategories.basic.bgm,
  },
  [VpBaseMethods.vpStopBgm]: {
    label: '暂停播放背景音乐',
    category: VpCategories.basic.bgm,
  },
  [VpBaseMethods.vpShakeScreen]: {
    label: '震屏效果',
    category: VpCategories.other,
    paramFormConfig: {
      duration: {
        title: '持续时长',
        component: 'input-append',
        field: {
          type: 'number',
        },
      },
      fequence: {
        title: '抖动频率',
        component: 'input-append',
        field: {
          type: 'number',
        },
      },
      xy: {
        title: '抖动最大距离',
        component: 'event-xy',
      },
    },
  },
  [VpBaseMethods.vpCompute]: {
    label: '赋值',
    category: VpCategories.other,
    paramFormConfig: {
      target: {
        title: '全局变量',
        component: 'select',
        field: {
          options: [],
        },
      },
      method: {
        title: '运算方法',
        component: 'select',
        field: {
          options: [],
        },
      },
      value: {
        title: '运算数',
        component: 'event-compute',
      },
    },
  },
  [VpBaseMethods.vpRetry]: {
    label: '重新试玩',
    category: VpCategories.other,
  },
}

// 音频
export const VpAudioMethods = {
  vpPlaySound: 'vpPlaySound',
  vpReplaySound: 'vpReplaySound',
  vpResumeSound: 'vpResumeSound',
  vpStopSound: 'vpStopSound',
}
const VpAudioAstAction = {
  [VpAudioMethods.vpPlaySound]: {
    label: '播放音效',
    category: VpCategories.audio,
    paramFormConfig: {
      isStop: {
        title: '是否从头播放',
        component: 'switch',
      },
      loop: {
        title: '无限循环',
        component: 'switch',
      },
      loopNumber: {
        title: '播放次数',
        component: 'input-number',
        field: {
          controlsPosition: 'right',
          min: 1,
        },
      },
    },
  },
  [VpAudioMethods.vpReplaySound]: {
    label: '从头播放音效',
    category: VpCategories.audio,
    paramFormConfig: {
      loop: {
        title: '无限循环',
        component: 'switch',
      },
      loopNumber: {
        title: '播放次数',
        component: 'input-number',
        field: {
          controlsPosition: 'right',
          min: 1,
        },
      },
      isStopSound: {
        title: '触发时停止播放上一次触发的音效',
        component: 'switch',
      },
    },
  },
  [VpAudioMethods.vpResumeSound]: {
    label: '继续播放音效',
    category: VpCategories.audio,
  },
  [VpAudioMethods.vpStopSound]: {
    label: '暂停播放音效',
    category: VpCategories.audio,
    paramFormConfig: {
      isStop: {
        title: '是否暂停当前场景全部音效',
        component: 'switch',
      },
    },
  },
}

// 视频
export const VpVideoMethods = {
  vpPlayVideo: 'vpPlayVideo',
  vpReplayVideo: 'vpReplayVideo',
  vpResumeVideo: 'vpResumeVideo',
  vpPauseVideo: 'pause',
  vpStopVideo: 'stop',
}
const VpVideoAstAction = {
  [VpVideoMethods.vpPlayVideo]: {
    label: '播放视频',
    category: VpCategories.video,
    paramFormConfig: {
      loopNumber: {
        title: '播放次数',
        component: 'input-number',
        field: {
          controlsPosition: 'right',
          min: 1,
        },
      },
      loop: {
        title: '无限循环',
        component: 'switch',
      },
      playEndFrame: {
        title: '保持尾帧',
        component: 'switch',
      },
    },
  },
  [VpVideoMethods.vpReplayVideo]: {
    label: '从头播放视频',
    category: VpCategories.video,
    paramFormConfig: {
      loopNumber: {
        title: '播放次数',
        component: 'input-number',
        field: {
          controlsPosition: 'right',
          min: 1,
        },
      },
      loop: {
        title: '无限循环',
        component: 'switch',
      },
      playEndFrame: {
        title: '保持尾帧',
        component: 'switch',
      },
    },
  },
  [VpVideoMethods.vpResumeVideo]: {
    label: '继续播放视频',
    category: VpCategories.video,
  },
  [VpVideoMethods.vpStopVideo]: {
    label: '暂停播放视频',
    category: VpCategories.video,
  },
  [VpVideoMethods.vpPauseVideo]: {
    label: '暂停播放视频',
    category: VpCategories.video,
  },
}

// 连线组件
export const VpDrawLineMethods = {
  vpEraseLine: 'vpEraseLine',
  vpModifyLineStyle: 'vpModifyLineStyle',
  vpEnablePair: 'vpEnablePair',
  vpFreeEraseLine: 'vpFreeEraseLine',
  vpFreeModifyLineStyle: 'vpFreeModifyLineStyle',
  vpFreeEnable: 'vpFreeEnable',
  vpFreeEnableRigidBody: 'vpFreeEnableRigidBody',
  vpModifyPairLineStyle: 'vpModifyPairLineStyle',
  vpEnableBanArea: 'vpEnableBanArea',
}
const VpDrawLineAstAction = {
  [VpDrawLineMethods.vpEraseLine]: {
    label: '抹除连线线条',
    category: VpCategories.drawLine,
    paramFormConfig: {
      pair: {
        title: '抹除对象',
        component: 'event-pair',
      },
    },
    actionTip: 'workbench.drawLine.drawLineEdit.vpEraseLineTip', // 这里不能直接写i18n,运行会报错
  },
  [VpDrawLineMethods.vpModifyLineStyle]: {
    label: '修改连线线条样式',
    category: VpCategories.drawLine,
    paramFormConfig: {
      area: {
        title: '起止区域',
        component: 'event-area',
      },
      lineColor: {
        title: '线条颜色',
        component: 'event-color',
      },
      lineStyle: {
        title: '线条粗细',
        component: 'input-number',
        field: {
          controlsPosition: 'right',
          min: 1,
        },
      },
    },
    actionTip: 'workbench.drawLine.drawLineEdit.vpModifyLineStyleTip', // 这里不能直接写i18n,运行会报错
  },
  [VpDrawLineMethods.vpEnablePair]: {
    label: '启用/禁用配对关系',
    category: VpCategories.drawLine,
    paramFormConfig: {
      pair: {
        title: '配对关系',
        component: 'event-pair',
      },
      enableBan: {
        title: '启用/禁用',
        component: 'select',
        field: {
          options: [
            {
              label: '启用',
              value: true,
            },
            {
              label: '禁用',
              value: false,
            },
          ],
        },
      },
    },
  },
  [VpDrawLineMethods.vpModifyPairLineStyle]: {
    label: '修改已连线配对的线条样式',
    category: VpCategories.drawLine,
    paramFormConfig: {
      pair: {
        title: '配对关系',
        component: 'event-pair',
      },
      lineColor: {
        title: '线条颜色',
        component: 'event-color',
      },
      lineStyle: {
        title: '线条粗细',
        component: 'input-number',
        field: {
          controlsPosition: 'right',
          min: 1,
        },
      },
    },
    actionTip: 'workbench.drawLine.drawLineEdit.vpModifyPairLineStyle', // 这里不能直接写i18n,运行会报错
  },
  [VpDrawLineMethods.vpEnableBanArea]: {
    label: '启用/禁用起止区域',
    category: VpCategories.drawLine,
    paramFormConfig: {
      area: {
        title: '起止区域',
        component: 'event-area',
      },
      enableBan: {
        title: '启用/禁用',
        component: 'select',
        field: {
          options: [
            {
              label: '启用',
              value: true,
            },
            {
              label: '禁用',
              value: false,
            },
          ],
        },
      },
    },
  },
}

const VpFreeDrawLineAstAction = {
  [VpDrawLineMethods.vpFreeEraseLine]: {
    label: '抹除画线线条',
    category: VpCategories.freeDrawLine,
    actionTip: 'workbench.drawLine.freeDrawLineEdit.vpFreeEraseLineTip', // 这里不能直接写i18n,运行会报错
  },
  [VpDrawLineMethods.vpFreeModifyLineStyle]: {
    label: '修改画线线条样式',
    category: VpCategories.freeDrawLine,
    paramFormConfig: {
      lineColor: {
        title: '线条颜色',
        component: 'event-color',
      },
      lineStyle: {
        title: '线条粗细',
        component: 'input-number',
        field: {
          controlsPosition: 'right',
          min: 1,
        },
      },
    },
    actionTip: 'workbench.drawLine.freeDrawLineEdit.vpFreeModifyLineStyleTip', // 这里不能直接写i18n,运行会报错
  },
  [VpDrawLineMethods.vpFreeEnable]: {
    label: '启用/禁用自由画线组件',
    category: VpCategories.freeDrawLine,
    paramFormConfig: {
      enableBan: {
        title: '启用/禁用',
        component: 'select',
        field: {
          options: [
            {
              label: '启用',
              value: true,
            },
            {
              label: '禁用',
              value: false,
            },
          ],
        },
      },
    },
  },
  [VpDrawLineMethods.vpFreeEnableRigidBody]: {
    label: '已画线条生成刚体',
    category: VpCategories.freeDrawLine,
  },
}
export const VpEraseMethods = {
  vpEnableEraseComponent: 'vpEnableEraseComponent',
  vpEraseTrace: 'vpEraseTrace',
  vpShowGroup: 'vpShowGroup',
  vpEnableEraseableGroup: 'vpEnableEraseableGroup',
  vpPlayAllMovieClipForGroup: 'vpPlayAllMovieClipForGroup',
  vpPauseAllMovieClipForGroup: 'vpPauseAllMovieClipForGroup',
  vpPlayTweenForGroup: 'vpPlayTweenForGroup',
  vpPauseTweenForGroup: 'vpPauseTweenForGroup',
  vpPlayTweenGoOnForGroup: 'vpPlayTweenGoOnForGroup',
  vpPlayAllTweenForGroup: 'vpPlayAllTweenForGroup',
  vpPauseAllTweenForGroup: 'vpPauseAllTweenForGroup',
  vpPlayAllTweenGoOnForGroup: 'vpPlayAllTweenGoOnForGroup',
  vpReplaceHandImage: 'vpReplaceHandImage',
}
const VpEraseAstAction = {
  [VpEraseMethods.vpEnableEraseComponent]: {
    label: '启用/禁用擦除组件',
    category: VpCategories.erase,
    paramFormConfig: {
      isEnable: {
        title: '启用/禁用',
        component: 'select',
        field: {
          options: [
            {
              label: '启用',
              value: true,
            },
            {
              label: '禁用',
              value: false,
            },
          ],
        },
      },
    },
  },
  [VpEraseMethods.vpEraseTrace]: {
    label: '清除擦除痕迹',
    category: VpCategories.erase,
    paramFormConfig: {},
  },
  [VpEraseMethods.vpShowGroup]: {
    label: '显示/隐藏分组',
    category: VpCategories.erase,
    paramFormConfig: {
      actionGroup: {
        title: '响应对象',
        component: 'select',
        field: {
          options: [],
        },
      },
      isShow: {
        title: '显示/隐藏',
        component: 'select',
        field: {
          options: [
            {
              label: '显示',
              value: true,
            },
            {
              label: '隐藏',
              value: false,
            },
          ],
        },
      },
    },
  },
  [VpEraseMethods.vpEnableEraseableGroup]: {
    label: '启用/禁用可被擦除分组',
    category: VpCategories.erase,
    paramFormConfig: {
      actionGroup: {
        title: '响应对象',
        component: 'select',
        field: {
          options: [],
        },
      },
      isEnable: {
        title: '启用/禁用',
        component: 'select',
        field: {
          options: [
            {
              label: '启用',
              value: true,
            },
            {
              label: '禁用',
              value: false,
            },
          ],
        },
      },
    },
  },
  [VpEraseMethods.vpPlayAllMovieClipForGroup]: {
    label: '显示并播放分组的全部序列帧',
    category: VpCategories.erase,
    paramFormConfig: {
      actionGroup: {
        title: '响应对象',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpEraseMethods.vpPauseAllMovieClipForGroup]: {
    label: '暂停播放分组的全部序列帧',
    category: VpCategories.erase,
    paramFormConfig: {
      actionGroup: {
        title: '响应对象',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpEraseMethods.vpPlayTweenForGroup]: {
    label: '播放分组的单个动画',
    category: VpCategories.erase,
    paramFormConfig: {
      actionGroup: {
        title: '响应对象',
        component: 'erase-group',
      },
      vpTweenUuid: {
        title: '选择动画',
        component: 'erase-tween',
      },
    },
  },
  [VpEraseMethods.vpPauseTweenForGroup]: {
    label: '暂停播放分组的单个动画',
    category: VpCategories.erase,
    paramFormConfig: {
      actionGroup: {
        title: '响应对象',
        component: 'erase-group',
      },
      vpTweenUuid: {
        title: '选择动画',
        component: 'erase-tween',
      },
    },
  },
  [VpEraseMethods.vpPlayTweenGoOnForGroup]: {
    label: '继续播放分组单个动画',
    category: VpCategories.erase,
    paramFormConfig: {
      actionGroup: {
        title: '响应对象',
        component: 'erase-group',
      },
      vpTweenUuid: {
        title: '选择动画',
        component: 'erase-tween',
      },
    },
  },
  [VpEraseMethods.vpPlayAllTweenForGroup]: {
    label: '播放分组的全部动画',
    category: VpCategories.erase,
    paramFormConfig: {
      actionGroup: {
        title: '响应对象',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpEraseMethods.vpPauseAllTweenForGroup]: {
    label: '暂停播放分组的全部动画',
    category: VpCategories.erase,
    paramFormConfig: {
      actionGroup: {
        title: '响应对象',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpEraseMethods.vpPlayAllTweenGoOnForGroup]: {
    label: '继续播放分组的全部动画',
    category: VpCategories.erase,
    paramFormConfig: {
      actionGroup: {
        title: '响应对象',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpEraseMethods.vpReplaceHandImage]: {
    label: '替换跟手图片',
    category: VpCategories.erase,
    paramFormConfig: {
      handImage: {
        title: '跟手图片',
        component: 'erase-hand-image',
      },
    },
  },
}

export const VpMethods = {
  ...VpTweenMethods,
  ...VpMovieClipMethods,
  ...VpDragonBoneMethods,
  ...VpParticleMethods,
  ...VpBaseMethods,
  ...VpAudioMethods,
  ...VpVideoMethods,
  ...VpDrawLineMethods,
  ...VpEraseMethods,
  ...VpMaskMethods,
  ...VpCarouselMethods,
}

let vpAstActionConfig: {
  [key: string]: EditorAstActionItem
} = {}
// astAction 配置，一般配置 UI 相关的内容，如多语言文本
// paramFormConfig 响应事件的参数的表单配置
// 编辑器要覆盖或修改脚本的配置之前，需要校验配置是否非 undefined，因为的更新逻辑跟编辑器并不是同步的
// 创建素材后，脚本就已经确定下来了，之后更新脚本都无法影响到已创建好的素材
export function getVpAstActionConfig() {
  if (_.isEmpty(vpAstActionConfig)) {
    // @ts-ignore
    vpAstActionConfig = _.merge(
      {
        ...VpTweenAstAction,
        ...VpMovieClipAstAction,
        ...VpDragonBoneAstAction,
        ...VpParticleAstAction,
        ...VpBasicAstAction,
        ...VpAudioAstAction,
        ...VpVideoAstAction,
        ...VpDrawLineAstAction,
        ...VpFreeDrawLineAstAction,
        ...VpEraseAstAction,
        ...VpCarouselAstAction,
        ...VpMaskAstAction,
      },
      i18n.t('workbench.eventSetting.action'),
    )
  }
  return vpAstActionConfig
}

/**
 * 获取响应事件参数的表单配置
 */
function pickResponseEventParamFormConfig({
  method,
  paramKeys,
}: {
  // 响应事件 method
  method: string
  // 要获取的表单配置的参数名称
  paramKeys: string[]
}) {
  const cur = vpAstActionConfig[method]
  if (cur && cur.paramFormConfig) {
    return _.pick(cur.paramFormConfig, paramKeys)
  }
  return {}
}

const getField = ({ field, component }: { field: any; component: string }) => {
  const newField = {
    ...field,
    size: 'mini',
  }
  if (component === 'switch') {
    const switchConfig = i18n.t(
      'workbench.eventSetting.component.switch',
    ) as Record<string, any>
    newField['active-text'] = switchConfig['active-text']
    newField['inactive-text'] = switchConfig['inactive-text']
  }
  return newField
}

/**
 * 脚本响应事件的配置来源有：编辑器默认配置 > 场景脚本的事件配置 > 脚本默认配置，编辑器的配置优先级最高
 * 将脚本的响应事件的参数的表单配置与编辑器的配置合并
 */
export function mergeResponseEventParamFormConfig({
  formConfig,
  method,
}: {
  formConfig: {
    [key: string]: any
  }
  method: string
}) {
  /* eslint-disable */
  const conf = formConfig
    ? _.merge(
      formConfig,
      pickResponseEventParamFormConfig({
        // 只提取有 initData 中配置了的属性
        paramKeys: Object.keys(formConfig),
        method,
      }),
    )
    : null
  // 补全表单控件数据，如 switch 组件提示文字
  if (conf) {
    _.each(conf, (value, key) => {
      if (value) {
        value.field = getField({
          field: value.field || {},
          component: value.component,
        })
      }
    })
  }
  return conf
}

export const HandConditionType = {
  CLICK: 'CLICK',
  DOWN: 'DOWN',
  UP: 'UP',
  SWIPE_LEFT: 'SWIPE_LEFT',
  SWIPE_RIGHT: 'SWIPE_RIGHT',
  SWIPE_UP: 'SWIPE_UP',
  SWIPE_DOWN: 'SWIPE_DOWN',
  SWIPE_ANY: 'SWIPE_ANY',
  HOLD: 'HOLD',
  DOUBLE_CLICK: 'DOUBLE_CLICK',
}
export const DragConditionType = {
  VPDRAG_START: 'VPDRAG_START',
  VPDRAG_END: 'VPDRAG_END',
  VPUNDRAG_END: 'VPUNDRAG_END',
}
export const SceneConditionType = {
  SCENECHANGE: 'scenechange',
}
export const CustomEventType = {
  CUSTOM_EVENT: 'CUSTOM_EVENT'
}
export const VideoConditionType = {
  VIDEO_PLAY_START: 'playLoopStart',
  VIDEO_PLAY_END: 'playLoopComplete',
}
export const AudioConditionType = {
  AUDIO_PLAY_START: 'audio_play_start',
  AUDIO_PLAY_END: 'audio_play_complete',
}
export const DrawLineConditionType = {
  DRAW_START: 'drawStart',
  DRAW_END: 'drawEnd',
  FREE_DRAW_START: 'freeDrawStart',
  FREE_DRAW_END: 'freeDrawEnd',
}
export const EraseConditionType = {
  ERASE_START: 'eraseStart',
  ERASE_UP: 'eraseUp',
  ERASE_REACH_STEP: 'eraseReachStep',
  ERASE_UN_REACH_STEP: 'eraseUnReachStep',
}

export const CarouselConditionType = {
  SWITCH_DONE: 'switchDone',
  RESOURCE_SWITCH_DONE: 'resourceSwitchDone',
  TAG_SWITCH_DONE: 'tagSwitchDone'
}
export const EventType = {
  click: 'CLICK',
  hold: 'HOLD',
  down: 'DOWN',
  up: 'UP',
  doubleClick: 'DOUBLE_CLICK',
  swipeUp: 'SWIPE_UP',
  swipeDown: 'SWIPE_DOWN',
  swipeLeft: 'SWIPE_LEFT',
  swipeRight: 'SWIPE_RIGHT',
  swipeAny: 'SWIPE_ANY',
}

export interface EventCondition {
  conditionLabel: string
  content: string
  node: string
  type: 'event'
  carousel?: {
    carouselId: string | string[]
    resourceUniqueNames: string[]
    tagIds: string[]
  }
}

type ConditionConfigItem = {
  command: string
  label: string
  icon: string
  type: 'event' | 'compare'
  content?: string
}

export const getVpConditionConf = (): {
  [key: string]: ConditionConfigItem[]
} => {
  // @ts-ignore
  const text: {
    [key: string]: string
  } = i18n.t('workbench.eventSetting.eventHand')
  return {
    click: [
      {
        command: EventType.click,
        label: text.click,
        icon: 'click',
        type: 'event',
        content: HandConditionType.CLICK,
      },
      {
        command: EventType.hold,
        label: text.hold,
        icon: 'long_press',
        type: 'event',
        content: HandConditionType.HOLD,
      },
      {
        command: EventType.down,
        label: text.down,
        icon: 'press',
        type: 'event',
        content: HandConditionType.DOWN,
      },
      {
        command: EventType.up,
        label: text.up,
        icon: 'lift',
        type: 'event',
        content: HandConditionType.UP,
      },
      {
        command: EventType.doubleClick,
        label: text.doubleClick,
        icon: 'double_click',
        type: 'event',
        content: HandConditionType.DOUBLE_CLICK,
      },
    ],
    swipe: [
      {
        command: EventType.swipeUp,
        label: text.swipeUp,
        icon: 'slide_up',
        type: 'event',
        content: HandConditionType.SWIPE_UP,
      },
      {
        command: EventType.swipeDown,
        label: text.swipeDown,
        icon: 'slide_downward',
        type: 'event',
        content: HandConditionType.SWIPE_DOWN,
      },
      {
        command: EventType.swipeLeft,
        label: text.swipeLeft,
        icon: 'left_slip',
        type: 'event',
        content: HandConditionType.SWIPE_LEFT,
      },
      {
        command: EventType.swipeRight,
        label: text.swipeRight,
        icon: 'right_slip',
        type: 'event',
        content: HandConditionType.SWIPE_RIGHT,
      },
      {
        command: EventType.swipeAny,
        label: text.swipeAny,
        icon: 'arbitrary_sliding',
        type: 'event',
        content: HandConditionType.SWIPE_ANY,
      },
    ],
    drag: [
      {
        command: 'VPDRAG_START',
        label: text.vpDragStart,
        icon: 'drag',
        type: 'event',
        content: DragConditionType.VPDRAG_START,
      },
      {
        command: 'VPDRAG',
        label: text.vpDragPosition,
        icon: 'drag_to_the_specified_location',
        type: 'event',
        content: DragConditionType.VPDRAG_END,
      },
      {
        command: 'VPUNDRAG',
        label: text.vpUnDragPosition,
        icon: 'drag_to_the_specified_location',
        type: 'event',
        content: DragConditionType.VPUNDRAG_END,
      },
    ],
    delay: [
      {
        command: 'ENTER_SCENE_DELAY',
        label: text.delay,
        icon: 'automatic_trigger',
        type: 'event',
        content: SceneConditionType.SCENECHANGE,
      },
    ],
    customEvent: [
      {
        command: 'CUSTOM_EVENT',
        label: text.customEvent,
        icon: 'ConditionCompare',
        type: 'event',
        content: CustomEventType.CUSTOM_EVENT
      }
    ],
    video: [
      {
        command: 'VIDEO_PLAY_START',
        label: text.videoStart,
        icon: 'at_the_beginning',
        type: 'event',
        content: VideoConditionType.VIDEO_PLAY_START,
      },
      {
        command: 'VIDEO_PLAY_END',
        label: text.videoEnd,
        icon: 'at_the_end',
        type: 'event',
        content: VideoConditionType.VIDEO_PLAY_END,
      },
    ],
    audio: [
      {
        command: 'AUDIO_PLAY_START',
        label: text.audioStart,
        icon: 'at_the_beginning',
        type: 'event',
        content: AudioConditionType.AUDIO_PLAY_START,
      },
      {
        command: 'AUDIO_PLAY_END',
        label: text.audioEnd,
        icon: 'at_the_end',
        type: 'event',
        content: AudioConditionType.AUDIO_PLAY_END,
      },
    ],
    logic: [
      {
        command: 'LOGIC',
        label: text.conditionIf,
        icon: 'ConditionCompare',
        type: 'compare',
      },
    ],
    drawLine: [
      {
        command: 'DRAW_START',
        label: text.drawStart,
        icon: 'ic_components',
        type: 'event',
        content: DrawLineConditionType.DRAW_START,
      },
      {
        command: 'DRAW_END',
        label: text.drawEnd,
        icon: 'ic_components',
        type: 'event',
        content: DrawLineConditionType.DRAW_END,
      },
    ],
    freeDrawLine: [
      {
        command: 'FREE_DRAW_START',
        label: text.freeDrawStart,
        icon: 'ic_press',
        type: 'event',
        content: DrawLineConditionType.FREE_DRAW_START,
      },
      {
        command: 'FREE_DRAW_END',
        label: text.freeDrawEnd,
        icon: 'ic_lift',
        type: 'event',
        content: DrawLineConditionType.FREE_DRAW_END,
      },
    ],
    erase: [
      {
        command: 'ERASE_START',
        label: text.eraseStart,
        icon: 'ic_components',
        type: 'event',
        content: EraseConditionType.ERASE_START,
        tip: i18n.t('workbench.erase.event.eraseStartTip')
      },
      {
        command: 'ERASE_UP',
        label: text.eraseUp,
        icon: 'ic_components',
        type: 'event',
        content: EraseConditionType.ERASE_UP,
        tip: i18n.t('workbench.erase.event.eraseUpTip')
      },
      {
        command: 'ERASE_REACH_STEP',
        label: text.eraseReachStep,
        icon: 'ic_components',
        type: 'event',
        content: EraseConditionType.ERASE_REACH_STEP,
        tip: i18n.t('workbench.erase.event.eraseReachStepTip')
      },
      {
        command: 'ERASE_UN_REACH_STEP',
        label: text.eraseUnReachStep,
        icon: 'ic_components',
        type: 'event',
        content: EraseConditionType.ERASE_UN_REACH_STEP,
        tip: i18n.t('workbench.erase.event.eraseUnReachStepTip')
      },
    ],
    carousel: [
      {
        command: 'SWITCH_DONE',
        label: i18n.t('workbench.carousel.condition.switchDone.label'),
        icon: 'ic_components',
        type: 'event',
        content: CarouselConditionType.SWITCH_DONE,
        tip: i18n.t('workbench.carousel.condition.switchDone.tip')
      },
      {
        command: 'RESOURCE_SWITCH_DONE',
        label: i18n.t('workbench.carousel.condition.resourceSwitchDone.label'),
        icon: 'ic_components',
        type: 'event',
        content: CarouselConditionType.RESOURCE_SWITCH_DONE,
        tip: i18n.t('workbench.carousel.condition.resourceSwitchDone.tip')
      },
      {
        command: 'TAG_SWITCH_DONE',
        label: i18n.t('workbench.carousel.condition.tagSwitchDone.label'),
        icon: 'ic_components',
        type: 'event',
        content: CarouselConditionType.TAG_SWITCH_DONE,
        tip: i18n.t('workbench.carousel.condition.tagSwitchDone.tip'),
      },
    ]
  }
}
